import { useEffect, useRef, useState } from 'react';

export default function CountdownCircle({ duration = 5000, size = 32, stroke = 4, color = '#3b82f6' }) {
  const [percent, setPercent] = useState(1);
  const startRef = useRef();

  useEffect(() => {
    setPercent(1);
    startRef.current = Date.now();
    let frameId;
    const tick = () => {
      const elapsed = Date.now() - startRef.current;
      const p = Math.max(0, 1 - elapsed / duration);
      setPercent(p);
      if (p > 0) {
        frameId = requestAnimationFrame(tick);
      }
    };
    frameId = requestAnimationFrame(tick);
    return () => {
      if (frameId) cancelAnimationFrame(frameId);
    };
  }, [duration]);

  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;

  return (
    <svg width={size} height={size} className="mx-2" style={{ minWidth: size, minHeight: size }}>
      <circle cx={size / 2} cy={size / 2} r={r} stroke="#e5e7eb" strokeWidth={stroke} fill="none" />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        stroke={color}
        strokeWidth={stroke}
        fill="none"
        strokeDasharray={c}
        strokeDashoffset={c * (1 - percent)}
        strokeLinecap="round"
        style={{
          transition: 'stroke-dashoffset 0.1s linear',
          transform: 'rotate(-90deg)',
          transformOrigin: '50% 50%',
        }}
      />
    </svg>
  );
}
